<template>
  <div class="componentSty">
    <m-title></m-title>
    <div class="componentSty_content">
      <div
        class="componentSty_content_box"
        style="width: 40%; border-right: 1px solid #f0f0f0"
      >
        <div class="componentSty_content_title">
          <span class="fonints">地区名称</span>
          <el-input
            placeholder="请输入关键词"
            v-model="conditions.name"
            clearable
          >
          </el-input>
          <button class="buttons" @click="selectinfo('left')">查询</button>
          <button
            class="buttons"
            style="background: orange"
            @click="addAreaListPc"
          >
            添加地区
          </button>
        </div>
        <div class="componentSty_content_table">
          <el-table
            :data="areaListPc.list"
            @row-click="tableRowClick"
            style="width: 100%; height: 80%"
            height="80%"
          >
            <el-table-column show-overflow-tooltip :render-header="renderHeader"
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
            <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="name" label="地区名称"></el-table-column>
            <el-table-column show-overflow-tooltip :render-header="renderHeader" label="操作">
              <template v-slot="res">
                <span
                  class="iconfont icon-xiugai"
                  @click="itemparticulars(res.row)"
                ></span>
                <span
                  class="iconfont icon-shanchu"
                  @click="delitem(res.row)"
                ></span>
              </template>
            </el-table-column>
          </el-table>
          <div class="paginations" v-show="areaListPc.list&&areaListPc.list.length">
            <el-pagination
              :page-size="conditions.limit"
              layout="total,prev, pager,next, jumper"
              :current-page="conditions.page"
              :total="areaListPc.totalCount"
              @current-change="getAreaListPc"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="componentSty_content_box" style="width: 60%">
        <div class="componentSty_content_title">
          <span class="fonints">流向名称</span>
          <el-input
            placeholder="请输入关键词"
            v-model="conditions2.customerName"
            clearable
          >
          </el-input>
          <button class="buttons" @click="selectinfo('right')">查询</button>
        </div>
        <div class="componentSty_content_table">
          <el-table :data="FlowInfo.list" style="width: 100%; height: 80%" border height="80%">
             <el-table-column show-overflow-tooltip :render-header="renderHeader"
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
            <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="areaName" label="地区名称">
            </el-table-column>
            <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="customerCode" label="流向编码">
            </el-table-column>
            <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="customerName" label="流向名称">
            </el-table-column>
            <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="memo" label="备注"> </el-table-column>
          </el-table>
          <div class="paginations" v-show="FlowInfo.list&&FlowInfo.list.length">
            <el-pagination
              v-if="FlowInfo.list"
              :page-size="conditions2.limit"
             layout="total,prev, pager,next, jumper"
              :current-page="conditions2.page"
              :total="FlowInfo.totalCount"
              
              @current-change="getFlowInfo"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <m-dialog :isShow="addrole" @changeState="sendMsg" :title="title">
        <div class="inForMsgBox">
          <div class="itemBox" style="width: 100%; margin: 20px 0">
            <span class="key" style="width: 21%">地区</span>
            <div class="val" style="background: #f3f4f5">
              <m-superIpt
                defaultInfo="请填写地区名称"
                v-model.trim="infoobj.name"
              ></m-superIpt>
            </div>
          </div>
        </div>
      </m-dialog>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import mDialog from "@/components/mDialog";
import mSuperIpt from "@/components/mSuperIpt";
import { antiShake } from "@/plugins/other.js";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      listitem: [{ name: "统计分析" }, { name: "详细流向" }],
      conditions: {},
      conditions2: {
        page: 1,
        limit: 20,
        areaId: null,
        areaName: null,
        customerName: null,
      },
      infoobj: {},
      title: "添加",
      addrole: false,
      FlowInfo: [],
      areaListPc: {},
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  components: {
    mTitle,
    mDialog,
    mSuperIpt,
  },
  created() {
    this.conditionsList[this.$route.path] ||
      this.createConditions({ key: this.$route.path });
    this.conditions = this.conditionsList[this.$route.path] || {
      page: 1,
      limit: 20,
    };
    this.getAreaListPc();
  },
  methods: {
    ...mapMutations(["createConditions"]),
    selectinfo(val) {
      antiShake((_) => {
        if (val == "left") {
          this.getAreaListPc();
        } else {
          this.getFlowInfo();
        }
      });
    },
    async getAreaListPc(num) {
      typeof num === "number" && (this.conditions.page = num);
      const { data } = await this.$http(
        "api1",
        "/sys/areaflow/getAreaListPc",
        "get",
        this.conditions
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.areaListPc = data.data;
      this.FlowInfo = [];
    },
    tableRowClick(row, item) {
      if (item.label == "操作") return "";
      this.getFlowInfo(row);
    },
    itemparticulars(row) {
      this.title = "修改";
      this.addrole = true;
      this.infoobj = Object.assign({}, row);
    },
    async delitem(row) {
      try {
        let val = await this.$messageBox.confirm(
          "此操作将永久删除该内容, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );
        if (val != "confirm") return "";
        const { data } = await this.$http(
          "api1",
          "/sys/areaflow/deleteArea",
          "post",
          { ids: [row.id] }
        );
        if (data.code != 0) return this.$message.error(data.msg);
        this.$message.success(`删除成功`);
        this.getAreaListPc();
      } catch {}
    },
    async sendMsg(item) {
      if (item != "confirm") {
        return (this.addrole = false);
      }
      if(!/^[\u4e00-\u9fa5]+$/.test(this.infoobj.name)) return this.$message.error("只能输入汉字");
      if (!this.infoobj.name) return this.$message.error("必填项不能为空");
      let api = "";
      if (this.title.includes("添加")) {
        api = "/sys/areaflow/saveArea";
      } else {
        api = "/sys/areaflow/updateArea";
      }
      const { data } = await this.$http("api1", api, "post", this.infoobj);
      if (data.code != 0) return this.$message.error(data.msg);
      this.$message.success(`${this.title}成功`);
      this.getAreaListPc();
      this.addrole = false;
    },
    addAreaListPc() {
      this.infoobj = {};
      this.addrole = true;
    },
    async getFlowInfo(row) {
      console.log(row);
      if (Object.prototype.toString.call(row) == "[object Object]") {
        this.conditions2.areaId = row.id;
        this.conditions2.areaName = row.name;
      }
      if (!this.conditions2.areaId || !this.conditions2.areaName)
        return this.$message.error("请选择左侧地区");
      typeof num === "number" && (this.conditions2.page = num);
      const { data } = await this.$http(
        "api1",
        "/externalservices/flow/flowlist",
        "get",
        this.conditions2
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.FlowInfo = data.data;
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
